<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">基本コミッション詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_BC_NEW>{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                :all="{ text: '全体', value: -1 }"
                :rules="[v => !!v || `適用海外取引先 is required`]"
                label="適用海外取引先"
                url="companies/kv?type=PARTNER"
                v-model="form.partnerId"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="[v => !!v || 'ｺﾐｯｼｮﾝレート is required']"
                clearable
                label="ｺﾐｯｼｮﾝレート"
                v-model="form.rate"
              />
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <date-picker label="適用開始日" v-model="form.startDate"/>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <date-picker :min="form.startDate" label="適用終了日" v-model="form.endDate"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {}
    }
  },
  methods: {
    save() {
      this.$http
        .post('/commission-rates', {
          ...this.form,
          partnerId: this.form.partnerId === -1 ? null : this.form.partnerId
        })
        .then(() => {
          this.$router.go(-1)
        })
    }
  }
}
</script>
